module.exports = __webpack_public_path__ + "img/epr-article-top-img.d3224c24.webp";